import { Pipe, PipeTransform } from '@angular/core';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'typeOfReservationSpecialDate',
  standalone: false,
})
export class TypeOfReservationSpecialDatePipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(value: number): any {
    let type: string = '';

    switch (value) {
      case AppConst.RESERVATION_SPECIAL_DATE_TYPE_HOLIDAY:
        type = this.translate.instant('休日');
        break;
      case AppConst.RESERVATION_SPECIAL_DATE_TYPE_SPECIAL:
      default:
        type = this.translate.instant('特別営業日');
        break;
    }
    return type;
  }
}
